import React from 'react';
import { debounce } from 'lodash';
import { TextField } from '@fluentui/react';

const TextFilter = ({fieldName, onChange, fieldLabel}) =>  {
    
    const onChangeDebounced = debounce(value => {
        onChange(fieldName, value.toLowerCase().trim());
    }, 500);

    return (
        <TextField
            label={`Search by ${fieldLabel}`}
            onChange={(e, val) => onChangeDebounced(val)}
            id={`search-${fieldName}`}
            type="text-box"
            autoComplete="off"
            name={fieldName}
        />
    );
}

export default TextFilter


// WEBPACK FOOTER //
// ./src/components/Administration/Filters/TextFilter.js